import React, { ComponentType } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Tooltip } from '@material-ui/core';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { Icon } from 'react-feather';

const ICON_SIZE = 32;

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    label: {},
    icon: {
      color: theme.palette.common.white,
    },
  });
});

export interface ChannelHeaderProps {
  label: string;
  icon:
    | ComponentType<{
        className?: string;
        color?: string;
        size?: string | number;
      }>
    | Icon;
  tooltip?: string;
}
const ChannelHeader = ({
  label,
  icon: IconComponent,
  tooltip = '',
}: ChannelHeaderProps) => {
  const classes = useStyles();

  return (
    <Tooltip title={tooltip} enterDelay={500} placement="top">
      <div className={classes.root}>
        <IconComponent className={classes.icon} size={ICON_SIZE} />
        <div className={classes.label}>{label}</div>
      </div>
    </Tooltip>
  );
};

export default ChannelHeader;
